import { EgretLoadable } from "egret";

const Inbox = EgretLoadable({
  loader: () => import("./AppInbox")
});
 

const adminUserChat = [
  {
        path: "/agentUserChat/*",
    exact: true,
    component: Inbox
    }, 
 
];

export default adminUserChat;
